export const COMPANY = {
  name: "Cherians Tech Solutions Private Limited",
  brand: "Cherians Tech Solutions",
  short: "CTS",
  tagline: "Technology Today for a Brighter Tomorrow",
  triad: "Technology. Solutions. Support.",
  phone: "062380 98067",
  phoneHref: "tel:+916238098067",
  mobile: "9495926291",
  mobileHref: "tel:+919495926291",
  email: "cherianstechsolutions@gmail.com",
  gst: "32AAJCC2042E1ZA",
  addressLines: [
    "Panickamuryil & Melekuttu Plaza,",
    "Central Junction,",
    "Mallappally West,",
    "Pathanamthitta District,",
    "Kerala - 689585",
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Cherians%20Tech%20Solutions%2C%20Central%20Junction%2C%20Mallappally%20West%2C%20Kerala%20689585&output=embed",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Cherians+Tech+Solutions%2C+Central+Junction%2C+Mallappally+West%2C+Kerala+689585",
  googleSearch:
    "https://www.google.com/search?q=Cherians+Tech+Solutions+Mallappally",
};

export const wa = (msg) =>
  `https://wa.me/919495926291?text=${encodeURIComponent(msg)}`;

export const WA_MESSAGES = {
  general: "Hello CTS, I would like to make an enquiry.",
  computer: "Hello CTS, I would like to enquire about an assembled computer.",
  printer: "Hello CTS, I would like to enquire about a printer.",
  toner: "Hello CTS, I need a toner. My printer model is ______.",
  networking: "Hello CTS, I need help with a networking requirement.",
  cctv: "Hello CTS, I would like to enquire about CCTV installation.",
  service: "Hello CTS, I need computer/laptop service.",
  business: "Hello CTS, I have a business IT requirement.",
  amc: "Hello CTS, I would like to know about the upcoming AMC service.",
  solar: "Hello CTS, I would like to know about the upcoming solar energy solutions.",
  ups: "Hello CTS, I would like to enquire about a UPS / power backup solution.",
};

export const REQUIREMENT_OPTIONS = [
  "Assembled PC",
  "Printer",
  "Toner / Consumables",
  "Computer Components & Accessories",
  "Networking",
  "CCTV",
  "Computer & Laptop Service",
  "Installation / Configuration",
  "Business IT Requirements",
  "AMC — Coming Soon",
  "Solar Energy Solutions — Coming Soon",
  "Institution / Institutional Requirement",
  "Other",
];

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Products",
    to: "/products",
    children: [
      { label: "Computers & Assembled PCs", to: "/products/assembled-computers" },
      { label: "Printers", to: "/products/printers" },
      { label: "Toners & Consumables", to: "/products/toners" },
      { label: "Computer Components & Accessories", to: "/products/components" },
      { label: "Networking Solutions", to: "/products/networking" },
      { label: "CCTV & Surveillance", to: "/products/cctv" },
      { label: "UPS & Power", to: "/products/ups" },
    ],
  },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "Computer & Laptop Service", to: "/services/computer-service" },
      { label: "Installation & Configuration", to: "/services/installation" },
      { label: "Networking Services", to: "/services/networking" },
      { label: "CCTV Installation", to: "/services/cctv-installation" },
      { label: "Solar Energy Solutions", to: "/services/solar", badge: "COMING SOON" },
    ],
  },
  {
    label: "Business Solutions",
    to: "/business-solutions",
    children: [
      { label: "Small Business", to: "/business-solutions/small-business" },
      { label: "Offices", to: "/business-solutions/offices" },
      { label: "Hospitals & Clinics", to: "/business-solutions/hospitals" },
      { label: "Banks & Financial Offices", to: "/business-solutions/banks" },
      { label: "Institutions", quote: "Institution / Institutional Requirement" },
    ],
  },
  { label: "AMC", to: "/amc", badge: "COMING SOON" },
  { label: "Projects", to: "/projects" },
  { label: "Technology Advice", to: "/technology-advice" },
  { label: "Podcasts", to: "/podcasts" },
  { label: "About", to: "/about" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroPc:
    "/cts-hero-4k.png",
  heroTech:
    "https://images.unsplash.com/photo-1597852074816-d933c7d2b988?auto=format&fit=crop&w=1200&q=70",
  circuit:
    "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=70",
  network:
    "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1200&q=70",
  cctv:
    "https://images.unsplash.com/photo-1765121689322-6befc57dc8db?auto=format&fit=crop&w=1200&q=70",
  printer:
    "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?auto=format&fit=crop&w=1200&q=70",
  toner:
    "https://images.unsplash.com/photo-1625465104350-6db75b747a1d?auto=format&fit=crop&w=1200&q=70",
  ups:
    "https://images.unsplash.com/photo-1740133306027-d05aa14ff579?auto=format&fit=crop&w=1200&q=70",
  solar:
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1200&q=70",
  office:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=70",
  workspace:
    "https://images.unsplash.com/photo-1591238372338-22d30c883a86?auto=format&fit=crop&w=1200&q=70",
  hospital:
    "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=70",
  bank:
    "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?auto=format&fit=crop&w=1200&q=70",
  smallbiz:
    "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=70",
  institution:
    "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1200&q=70",
  servers:
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1200&q=70",
};
